import { ChakraBox, ChakraText, DropdownV2, InputGroupV2 } from '@equip.health/ui';

import ConfirmModal from '~/components/common/ConfirmModal';

const TOP_LEVEL_ID = 'clinical-measurement-modal__key-vitals__void';

type VoidKeyVitalsModalProps = {
  isError: boolean;
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onSelect: (val: string) => void;
  voidReasons: { label: string; value: string }[];
  voidReasonValue: string;
};

const VoidKeyVitalsModal = ({
  isError,
  isLoading,
  isOpen,
  onClose,
  onConfirm,
  onSelect,
  voidReasons,
  voidReasonValue,
}: VoidKeyVitalsModalProps) => (
  <ConfirmModal
    body="Are you sure you want to void this entry? It's impossible to undo this action."
    cancelLabel="Cancel"
    confirmLabel="Void entry"
    confirmVariant="accent.critical"
    id={TOP_LEVEL_ID}
    isDisabled={isLoading || !voidReasonValue}
    isLoading={isLoading}
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title="Void entry"
  >
    <ChakraBox margin="12px 0px">
      <InputGroupV2
        id={`${TOP_LEVEL_ID}__void-reason-group`}
        isRequired
        label="Void reason"
        shouldShowAsteriskWhenRequired
      >
        <DropdownV2
          ariaLabel="Void reason"
          id={`${TOP_LEVEL_ID}__void-reason`}
          menuOptions={voidReasons}
          onOptionClick={(value) => onSelect(value ?? '')}
          placeholder="Select one option..."
          value={voidReasonValue}
        />
      </InputGroupV2>
    </ChakraBox>
    {isError && (
      <ChakraText
        color="critical.text"
        fontSize="12px"
        id={`${TOP_LEVEL_ID}-error`}
        paddingTop="24px"
      >
        Error voiding observation
      </ChakraText>
    )}
  </ConfirmModal>
);

export default VoidKeyVitalsModal;
